import * as Routes from '@/modules/routes';
import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../GradesTableQueryClientProvider';
import { IClassroom, IExerciseResult, ILesson } from '../../../types';

// AIDEV-NOTE: stable identity matters — useVideoActivityColumn memoizes on this array, and a fresh
// [] each render would remount every cell (flexRender treats the inline `cell` arrow as the
// component type), which re-registers observers and refetches in a loop.
const EMPTY: IExerciseResult[] = [];

const useVideoActivityExerciseResult = (classroom: IClassroom, lesson: ILesson) => {
  const isEnabled = !!(classroom?.id && lesson?.id);

  const query = useQuery([QueryKeys.VideoActivityExerciseResults, classroom.id, lesson?.id], () => {
    const path = Routes.plato_api_video_activity_result_exercise_results_path({
      only: [
        'id', 'student_id', 'exercise_type', 'exercise_id', 'score', 'completed_at',
        'requires_clever_passback', 'lms_settings', 'updated_since_graded',
      ],
      classroom_id: classroom.id,
      lesson_id: lesson.id,
    });

    // AIDEV-NOTE: deliberately no .catch — swallowing the rejection returns void, which widens the
    // queryFn's type and defeats the EMPTY fallback below. v4 turns a resolved-undefined into an
    // error regardless, so catching only cost us the real axios message.
    return axios
      .get<{ data: IExerciseResult[] }>(path)
      .then(res => res.data.data);
  }, { staleTime: Infinity, enabled: isEnabled });

  return { ...query, data: query.data ?? EMPTY, isEnabled };
};

export default useVideoActivityExerciseResult;
